class CommandWaitModel {
    wait = '0';

    toString() {
        return this.wait;
    }
}

export default CommandWaitModel;